import { StubPage } from "@/components/layout/StubPage";

export default function PrivacyPage() {
  return (
    <StubPage
      title="Privacy Policy"
      description="Our privacy policy is being drafted. Expect transparency around analytics, custody, and data retention."
    >
      <p className="text-sm text-slate-600">
        Until finalized, assume standard non-custodial best practices: no seed phrases
        collected, minimal analytics, and revocable permissions.
      </p>
    </StubPage>
  );
}
